import React, { useEffect, useState } from 'react';
import {Platform, Text, View, StyleSheet,Button, Alert,FlatList, Image,TouchableOpacity, SafeAreaView, ScrollView  } from 'react-native'
import { WebView } from 'react-native-webview';
import Modal from "react-native-modal";
import { useNavigation } from '@react-navigation/native';
import { useTailwind } from 'tailwind-rn';
import * as FileSystem from 'expo-file-system';
import GeneratedElelemntSublist from './GeneratedElementSublist';
import RenderHtml from 'react-native-render-html';



const GeneratedElelemnt = ({ tipo, align, firsttext, ordered, initial, text, listelements }) => {

    console.log("------------Elemento generado-------------") 

    const tailwind = useTailwind();
    const [isModalVisible, setModalVisible] = useState(false);

    const toggleModal = (number) => {
        console.log("activate view ",number)
        setModalVisible(!isModalVisible);
    };

    console.log("Tipo: " + tipo)


    if (tipo == "text") 
    {
        return (
            <View style ={ tailwind("") }>
                {
                <RenderHtml
                    source = {{
                        html: `<p style='text-align:justify;'>` + text["esp"] + `</p>`
                    }}
                />
                }
            </View>
        )
    }
    if (tipo == "list") 
    {
        console.log("dibujando la lista");
        if (ordered != null)
        {
            console.log(" ordered " + ordered.toString() );
            console.log( initial.toString() );    
        }else
        {
            console.log("NO existe ordered");
        }

        return (
            <View style ={ tailwind("") }>
                {
                    firsttext != "" ?
                    <RenderHtml
                        source = {{
                            html: `<p style='text-align:justify;'>` + firsttext["esp"] + `</p>`
                        }}
                    />
                    :
                        null
                }
                {
                    listelements["esp"].map((elementlist, index) => {
                        if (ordered)
                        {
                            return (
                                <RenderHtml
                                    source = {{
                                        html: `<p style='text-align:justify;'>`+ index.toString()  +`.- ` + elementlist + `</p>`
                                    }}
                                />
                            )
                        }else{
                            return (
                                <RenderHtml
                                    source = {{
                                        html: `<p style='text-align:justify;'> - ` + elementlist + `</p>`
                                    }}
                                />
                            )
                        }
                    })
                }
            </View>
        )
    }
    if (tipo == "listsubelement")
    {
        console.log("lista de elementos");
        console.log(listelements);

        return (
            <View style ={ tailwind("") }>
            {
                firsttext != "" ?
                    <RenderHtml
                        source = {{
                            html: `<p style='text-align:justify;'> - ` + firsttext["esp"] + `</p>`
                        }}
                    /> 
                :
                    null 
            }
            {
                    listelements.map((elementlist, index) => {
                        return (
                            <GeneratedElelemnt
                                tipo = {elementlist["tipo"]}
                                firsttext = {elementlist["firsttext"]}
                                text = {elementlist["text"]}
                                align = {elementlist["align"]}
                                listelements = {elementlist["listelements"]}
                                ordered = { elementlist["ordered"] }
                                initial = { elementlist["initial"] }
                            />
                        )
                    })
            }
           
        </View>
        )
    } 


    if (tipo == "imagen")
    {
        return (
            <View style ={ tailwind("") }>
                <Text style ={ tailwind("text-center") }>Imagen</Text>
            </View>
        )
    }

 

}

export default GeneratedElelemnt